import * as React from 'react';
import { Text } from '@lightspeed/flame/Text';
import Localize from 'app/src/localize/Localize';
import Format from 'app/src/data/Format';
import PaymentTypeManager from 'app/src/payments/PaymentTypeManager';
import { usePaymentContext } from '../Store/PaymentState';
import { UserDefinedPaymentTypeForm } from '../components/UserDefinedPaymentTypeForm';

export const CreditInputForm = () => {
  const creditAccountPaymentTypeID = PaymentTypeManager.getPaymentIdForType(
    PaymentTypeManager.Types.CREDIT_ACCOUNT
  );
  const { saleManager } = usePaymentContext();
  const availableCreditBalance = saleManager.availableCreditBalance;

  return (
    <>
      {availableCreditBalance && availableCreditBalance.isGreaterThan(0) && (
        <>
          <UserDefinedPaymentTypeForm name="Account" paymentTypeID={creditAccountPaymentTypeID} />
          <Text pr={1} title="Available Credit" textTransform="capitalize">
            {Localize.translate('Available: ')}
            {Format.formatMoney(availableCreditBalance, 0, false)}
          </Text>
        </>
      )}
    </>
  );
};
